import {ITranslationService} from "./translation.service.interface";

export class TranslationsHelper {
    constructor(private readonly translation: ITranslationService) {
    }

    minutes(value: number): string {
        if (value === 1) {
            return this.translation.translate('ONE_MINUTE');
        }
        return this.translation.translate('X_MINUTES', {x: value});
    }

    hours(value: number): string {
        if(value === 1) {
            return this.translation.translate('ONE_HOUR');
        }
        return this.translation.translate('X_HOURS', {x: value});
    }

    days(value: number): string {

        if(value === 1) {
            return this.translation.translate('ONE_DAY');
        }
        return this.translation.translate('X_DAYS', {x: value});
    }

    week(): string {
        return this.translation.translate('ONE_WEEK');
    }

    month(): string {
        return this.translation.translate('ONE_MONTH');
    }
}